<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData= $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:cancel="cancelHandler"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";


import GroupInsurancePolicyForm from "../../../components/insurance/groupinsurancepolicy/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": GroupInsurancePolicyForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle:this.$t('setuppolicymaster.editgrpinsurancepolicy'),
      pageTitleValue: "",
      formData: [],
      // formData: {
      //   policyno: null,
      //   startdate: null,
      //   enddate: null,
      //   policydesc: null,
      //   insproviderid: null,
      //   remark: null,
      //   expformatid: null,
      //   //logicscrpt: null,
      //   stamp: 0,
      //   userid: this.$store.getters.userId,
      // },

      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {

    errorHandler($event) {
    this.isErr = $event.isErr;
    this.errMsg = $event.errMsg;
    },

    loadGroupInsurancePolicyHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/groupinsurancepolicy/" + vm.id})
        .then((res) => {

          if (res.data.rec[0].startdate) {
              vm.formData.startdate = moment(res.data.rec[0].startdate).format(
              "YYYY-MM-DD"
            );
          }

          if (res.data.rec[0].enddate) {
              vm.formData.enddate = moment(res.data.rec[0].enddate).format(
              "YYYY-MM-DD"
            );
          }

          vm.formData.policyno = res.data.rec[0].policyno;
          vm.formData.insproviderid = res.data.rec[0].insproviderid;
          vm.formData.remark = res.data.rec[0].remark;
          vm.formData.expformatid = res.data.rec[0].expformatid;
          vm.formData.policydesc= res.data.rec[0].policydesc;
  
          vm.formData.stamp = res.data.rec[0].stamp;
          vm.formData.userid = this.$store.getters.userId;
          
          vm.pageTitleValue = res.data.rec[0].policyno;

          this.loadCoverageTypeHandler();
         // vm.loading = false;

        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    
    loadCoverageTypeHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/groupinsurancepolicydetail/" + this.id})
        .then((res) => {
          vm.formData.groupinsurancepolicydetail = res.data.rec;
         
        // for (let i = 0; i < res.data.rec.length; i++) {
        //     if (res.data.rec[i].receiptdate) {
        //       vm.formData.trainingrecorddetail[i].receiptdate = moment(
        //         res.data.rec[i].receiptdate
        //       ).format("YYYY-MM-DD");
        //     }
        //   }
          

          for (let i = 0; i < vm.formData.groupinsurancepolicydetail.length; i++) {
            Object.assign(vm.formData.groupinsurancepolicydetail[i], {
              action: 2,
            });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },


    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/groupinsurancepolicy/" + vm.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "groupinsurancepolicylist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

      cancelHandler() {
      this.$router.push({ name: "groupinsurancepolicylist" });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

         this.$store.dispatch('delete', {url:
            "/groupinsurancepolicy/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "groupinsurancepolicylist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "groupinsurancepolicynew" });
    },
  },

  async mounted() {
    await this.loadGroupInsurancePolicyHandler();
  },
};
</script>